import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  Stack,
  Text,
} from "@aksara-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRaffleCode, storeRaffleWinner } from "redux/actions";

interface Props {
  cityId: string;
}

const AddWinnerModal: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  cityId,
}) => {
  const dispatch = useDispatch();
  const { winner } = useSelector((state: any) => state.raffleReducer);
  const { isFormLoading } = useSelector(
    (state: any) => state.raffleWinnerReducer
  );
  const [raffleCode, setRaffleCode] = useState("");
  const [animatedNumber, setAnimatedNumber] = useState("");

  const handleCloseModal = () => {
    onClose && onClose();
    setRaffleCode("");
    setAnimatedNumber("");
  };

  const handleStoreRaffleWinner = (raffleCode: string) => {
    dispatch(
      storeRaffleWinner({ raffleCode, cityId }, handleCloseModal) as any
    );
  };

  useEffect(() => {
    let animationInterval: NodeJS.Timeout;

    if (isOpen && !raffleCode) {
      dispatch(getRaffleCode(cityId) as any);
      // Start the number animation
      animationInterval = setInterval(() => {
        setAnimatedNumber(
          Math.floor(Math.random() * 999999)
            .toString()
            .padStart(6, "0")
        );
      }, 100);

      // Stop the animation after 1 seconds and set the actual raffle code
      setTimeout(() => {
        clearInterval(animationInterval);
        setRaffleCode(
          winner && winner.raffle_code ? winner.raffle_code : "000000"
        );
      }, 1000);
    }

    // Cleanup interval on component unmount
    return () => {
      if (animationInterval) {
        clearInterval(animationInterval);
      }
    };
  }, [isOpen, raffleCode, winner]);

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
    >
      <DialogHeader></DialogHeader>
      <DialogContent>
        <Box
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
          style={{ gap: 20 }}
        >
          <Text scale={300}>Raffle Winner</Text>
          <Text scale={800} fontWeight={"bold"}>
            {raffleCode ? raffleCode : animatedNumber}
          </Text>
        </Box>
      </DialogContent>
      <DialogFooter>
        <Stack
          display="flex"
          flexDirection="row"
          spacing="xs"
          flex={1}
          style={{ gap: 15 }}
        >
          <Button
            type="submit"
            isLoading={isFormLoading}
            block
            variant="primary"
            onClick={() => handleStoreRaffleWinner(raffleCode)}
          >
            Add Raffle Winner
          </Button>
        </Stack>
      </DialogFooter>
    </Dialog>
  );
};

export default AddWinnerModal;
